import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  container: {
    // minHeight: "100vh",
  },
  headingBox: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px 20px",
  },
  heading: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "35px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
      lineHeight: "27px",
    },
  },
  subHeading: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "20px",
    color: "#B9B8B8",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
      marginTop: "10px",
    },
  },
  employeContainer: {
    padding: "0px 40px",
    width: "100%",
    display: "flex",
    flexDirection: "row",
  },
  imageBox: {
    width: "187px",
    height: "187px",
    borderRadius: "5%",
  },
  nameBox: {
    display: "flex",
    justifyContent: "center",
    padding: "10px",
  },
  nameText: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
  },
  tagsContainer: {
    width: "100%",
    padding: "0px 20px 20px 20px",
    textAlign: "center",
  },
  tagText: {
    color: "3E3E3E",
    padding: "7px",
    border: "1px solid #B9B8B8",
    display: "inline-block",
    borderRadius: "50px",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    margin: 5,
    backgroundColor: "rgb(229, 229, 229,0.2)",
    cursor: "pointer",
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
    },
  },
  tagTextActive: {
    padding: "7px",
    border: "1px solid #B9B8B8",
    display: "inline-block",
    borderRadius: "50px",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    margin: 5,
    backgroundColor: "rgb(78, 228, 69, 0.3)!important",
    // color: "#fff",
    cursor: "pointer",
  },
}));
